import { useState } from "react";
import { Input } from "V2.0/common/input";
import { Button } from "V2.0/common/button";
import Joi from "joi-browser";
import { message } from "antd";

function Domains(props) {
  const { domainIdentifiers, handleAddDomainIdentifier } = props;

  const [domainIdentifier, setDomainIdentifier] = useState("");
  const [error, setError] = useState(false);

  const isAddDisabled = !Boolean(domainIdentifier);

  const validate = () => Joi.string().uri().validate(domainIdentifier);

  const onAdd = () => {
    try {
      const url = new URL(domainIdentifier);

      if (url.origin === "null") {
        setError(true);
        message.error("Invalid URL");
        return;
      }

      const payload = {
        domains: [...domainIdentifiers, url.origin],
      };

      handleAddDomainIdentifier(payload, () => setDomainIdentifier(""));
    } catch (e) {
      setError(true);
      message.error("Invalid URL");
      return;
    }
  };

  return (
    <div className="flex gap-x-2">
      <Input
        className="w-24"
        placeholder="https://www.example.com"
        type="text"
        value={domainIdentifier}
        onChange={(e) => {
          setDomainIdentifier(e.target.value);
          if (error) {
            setError(false);
          }
        }}
        invalid={error}
      />
      <div className="flex-none">
        <Button onClick={onAdd} disabled={isAddDisabled}>
          Add Domain
        </Button>
      </div>
    </div>
  );
}

export default Domains;
